import { render, staticRenderFns } from "./PodrAddMain.vue?vue&type=template&id=08babd41&scoped=true&"
import script from "./PodrAddMain.vue?vue&type=script&lang=js&"
export * from "./PodrAddMain.vue?vue&type=script&lang=js&"
import style0 from "./PodrAddMain.vue?vue&type=style&index=0&id=08babd41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08babd41",
  null
  
)

export default component.exports